<template>
    <b-dropdown :text="$t('people.filters.filters')" :v-model="selectedFilter" variant="primary">
        <div class="ovy-auto" id="filters-div">
            <div v-if="filters.public.length > 0">
                <b-dropdown-header>
                    {{ $t('people.filters.header.public') }}
                </b-dropdown-header>
                <dropdown-item
                    v-for="(filter, index) in filters.public"
                    :key="'public-' + index"
                    :filter="filter"
                    :filter-index="'public-' + index"
                    :can-edit-filter="canEditFilter"
                    @toggleSubDropdowns="toggleSubDropdowns"
                    ref="subDropdowns"
                />
            </div>
            <div v-if="filters.private.length > 0">
                <b-dropdown-header>
                    {{ $t('people.filters.header.private') }}
                </b-dropdown-header>
                <dropdown-item
                    v-for="(filter, index) in filters.private"
                    :key="'private-' + index"
                    :filter="filter"
                    :filter-index="'private-' + index"
                    :can-edit-filter="canEditFilter"
                    @toggleSubDropdowns="toggleSubDropdowns"
                    ref="subDropdowns"
                />
            </div>
        </div>
        <div class="text-center p-1">
            <b-dropdown-divider />
            <b-button variant="primary" class="w-100" @click="createFilter()">
                {{ $t('people.filters.create.title') }}
            </b-button>
        </div>
    </b-dropdown>
</template>
<script>
import DropdownItem from './child/DropdownItem'

export default {
    name: 'Filters',
    components: {
        DropdownItem,
    },
    data() {
        return {
            filters: {
                public: [],
                private: [],
            },
            selectedFilter: {},
        }
    },
    created() {
        this.$store.watch(
            (state) => state.defaultFilters.filters,
            (filters) => {
                this.filters = filters
            }
        )
        this.$store.dispatch('getFilters')
    },
    methods: {
        createFilter() {
            this.$router.push({
                path: '/v2/people/list/create-filter',
            })
        },
        toggleSubDropdowns(filterIndex) {
            if (this.$refs.subDropdowns) {
                this.$refs.subDropdowns.forEach((subDropdown) => {
                    if (subDropdown.filterIndex != filterIndex) {
                        subDropdown.isDropdownShow = false
                    } else {
                        subDropdown.isDropdownShow = !subDropdown.isDropdownShow
                    }
                })
            }
        },
    },
    computed: {
        canEditFilter() {
            const role = this.$store.state.currentUser.user.role.name
            return ['god', 'administrator', 'local_administrator'].includes(role)
        },
    },
}
</script>

<style lang="sass" scoped>

.ovy-auto
    overflow-y: auto
    min-width: 450px
    max-height: 300px
.full-right
    cursor: pointer
    transition: 0.5s ease all
    padding: 5px
    &:hover
        color: #20a8d8

@media (max-width: 414px)
    .ovy-auto
        min-width: 300px
</style>
